module.exports = __webpack_public_path__ + "static/photo27@2x-ae58e24be037744b3ec00442b5637de6.png";